<div
  class="simple-card"
  [ngClass]="getCardClasses()"
  [id]="id"
  [style.--background-image]="backgroundImage ? 'url(' + backgroundImage + ')' : null"
>
  <div class="simple-card-header" *ngIf="showHeader && cardTitle" [style.font-size]="titleFontSize">
    {{ cardTitle }}
  </div>
  <div
    class="simple-card-content"
    [ngClass]="{
      'content-flex-wrap': contentLayout === 'flex-wrap'
    }"
  >
    <ng-content></ng-content>
  </div>
</div>
